<template>
    <div class="HeaderPoints">
        <div class="d-flex justify-content-between">
            <div style="text-align: center">
                <h4 class="mr-3">{{calculateClosingPoints(schemeEnrollmentObj, schemeDetail)}}</h4>
                <h6 style="font-size: 14px; margin-top: -5px; text-align: center;">REDEEMABLE POINTS</h6>
            </div>
            <div>
                <div style="text-align: center">
                    <h4 class="mr-3">{{calculateTotalPoints(schemeEnrollmentObj, schemeDetail)}}</h4>
                    <h6 style="font-size: 14px; margin-top: -5px; text-align: center;">TOTAL POINTS</h6>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'HeaderPoints',
    props: ['schemeEnrollmentObj', 'schemeDetail'],
  }
</script>

<style scoped>

</style>
